import { Module } from "vuex"
import PnpToolState from "./types";
import { pnpToolGetters } from "./getters";
import { pnpToolMutations } from "./mutations";
import { pnpToolActions } from "./actions";
import PnpItem from "../../../models/PnpItem";

const pnpToolState: PnpToolState = {
    toolMap: new Map<string, boolean>(),
    pnpItemArray: new Array<PnpItem>()
}

const PnpToolStore: Module<PnpToolState, never> = {
    state: pnpToolState,
    getters: pnpToolGetters,
    mutations: pnpToolMutations,
    actions: pnpToolActions
}

export default PnpToolStore;
